import { useOutletContext } from "react-router-dom"
import { Grid } from "@mui/material"
import AlertSettingsMovedNotice from "widgets/alerts/settings/AlertSettingsMovedNotice"

import type { Powerline } from "types/powerlines.types"

import ConductorsCard from "widgets/powerlines/settings/ConductorsCard"
import PowerlineDetails from "widgets/powerlines/settings/PowerlineDetails"
import { BodyContainer } from "widgets/styled/containers"

function PowerlineSettings() {
  const { powerline } = useOutletContext<{ powerline: Powerline }>()

  return (
    <BodyContainer disableGutters maxWidth="xl" sx={{ pt: 2 }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <AlertSettingsMovedNotice />
        </Grid>
        <Grid item xs={12}>
          <PowerlineDetails powerline={powerline} />
        </Grid>
        <Grid item xs={12}>
          <ConductorsCard powerline={powerline} />
        </Grid>
      </Grid>
    </BodyContainer>
  )
}

export default PowerlineSettings
